import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const PhoneCarouselContainer = styled.div`
  max-width: 100vw !important;
  margin: 0 auto;
  background: linear-gradient(180deg, #000000 43.4%, #411783 100%);;
`

export const PhoneCarouselContent = styled.div`
  display: grid;
  grid-row-gap: 3rem;
  justify-self: center;
  max-width: 1500px;
  margin: 0 auto;
  box-sizing: border-box;
  padding-bottom: 8.1rem;

  @media screen and (max-width: ${layout.sm}) {
    padding-bottom: 2.75rem;
    grid-row-gap: 1.5rem;
  }
`

export const PhoneCarouselTextContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  justify-content: center;
  grid-row-gap: 3rem;
  box-sizing: border-box;
  padding: 0 5rem;

  > h1 {
    max-width: 950px;
    margin: 0 auto;
    justify-self: center;
  }

  @media screen and (max-width: ${layout.sm}) {
    padding: 0 2.3rem;
    grid-row-gap: 1.5rem;
  }
`

export const CarouselContainer = styled.div`
  display: grid;

  div:last-child {
    color: ${palette.white};
    font-size: 1.1rem;
    text-transform: uppercase;

    h1 {
      max-width: 220px;
      justify-self: center;
      margin: 0 auto;
    }
  }

  @media screen and (max-width: ${layout.sm}) {
    div:last-child h1 {
      font-size: 1.2rem;
    }
  }
`
